module.exports = __webpack_public_path__ + "img/tms02.3024d40d.png";